var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 219"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4629 7.42871L5.53981 13.8573",
    stroke: "red",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4629 7.42871L5.53981 13.8573",
    stroke: "red",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 7.42871L12.4621 13.8573",
    stroke: "red",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 7.42871L12.4621 13.8573",
    stroke: "red",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 208",
    d: "M5.53906 2.28613H12.4621V2.28613C12.4621 1.57605 11.8865 1.00042 11.1764 1.00042H6.82478C6.1147 1.00042 5.53906 1.57605 5.53906 2.28613V2.28613Z",
    stroke: "red"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 0.5,
    y1: 3.07129,
    x2: 17.5,
    y2: 3.07129,
    stroke: "red",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 209",
    d: "M2.47531 2.78613H15.525C15.8182 2.78613 16.0485 3.03726 16.0231 3.32936L14.7461 18.0436C14.7237 18.3021 14.5074 18.5004 14.248 18.5004H3.75229C3.4929 18.5004 3.27659 18.3021 3.25416 18.0436L1.97718 3.32936C1.95183 3.03726 2.18211 2.78613 2.47531 2.78613Z",
    stroke: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.9893659c022e6f0620bc166ec032ceb1.svg";
export { ForwardRef as ReactComponent };